import { FC } from "react";
import { HiOutlineShare } from "react-icons/hi";
import { Event } from "@modules/for-you/types";
import Toast from "@common/components/Toast";
import cx from "classnames";
import { useEventListItem } from "@modules/for-you/hooks";
import { Typography } from "@earned/core";
import { themeTextColors } from "@common/constants";

export interface EventListItemProps {
  event: Event;
}

const EventListItem: FC<EventListItemProps> = ({ event }) => {
  const { formattedDate, copyEventUrlToClipboard, linkToWebsite } =
    useEventListItem(event);

  return (
    <div className="flex h-full flex-col border-b border-primary pb-2 pt-3">
      <div
        className={cx("flex flex-col gap-2 pb-4", {
          "cursor-pointer": !!event.WEBSITE,
        })}
        onClick={linkToWebsite}
      >
        <Typography variant="body-sm" color="secondary">
          {formattedDate}
        </Typography>
        <Typography variant="body" weight="medium" color="secondary">
          {event.NAME}
        </Typography>
        {event.LOCATION && (
          <Typography variant="body" color="secondary">
            {event.LOCATION}
          </Typography>
        )}
        <Typography variant="body" color="secondary">
          <span
            className={cx({
              "line-clamp-3": !!event.LOCATION,
            })}
          >
            {event.EVENT_NAME}
          </span>
        </Typography>
      </div>
      {event.WEBSITE && (
        <Toast message="Event URL copied to clipboard!" placement="left">
          <div
            className="flex flex-row items-center justify-center gap-2"
            onClick={copyEventUrlToClipboard}
          >
            <HiOutlineShare color={themeTextColors.primary} size={16} />
            <Typography variant="body" color="secondary" weight="medium">
              <span className="my-auto">Share this event</span>
            </Typography>
          </div>
        </Toast>
      )}
    </div>
  );
};

export default EventListItem;
